import { ExamplePageTemplate } from "./components";
import { ecommerceConfig } from "./configs/exampleConfigs";

const EcommerceExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={ecommerceConfig.backgroundColor}
      chatButtonColor={ecommerceConfig.chatButtonColor}
      chatButtonIcon={ecommerceConfig.chatButtonIcon}
      header={ecommerceConfig.header}
      hero={ecommerceConfig.hero}
    >
      {ecommerceConfig.content}
    </ExamplePageTemplate>
  );
};

export default EcommerceExample;